module.exports = __webpack_public_path__ + "img/4.fa518764.png";